/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeleteTeamMemberRequest
 */
export interface DeleteTeamMemberRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteTeamMemberRequest
   */
  teamMemberId: string;
}

/**
 * Check if a given object implements the DeleteTeamMemberRequest interface.
 */
export function instanceOfDeleteTeamMemberRequest(
  value: object,
): value is DeleteTeamMemberRequest {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  return true;
}

export function DeleteTeamMemberRequestFromJSON(
  json: any,
): DeleteTeamMemberRequest {
  return DeleteTeamMemberRequestFromJSONTyped(json, false);
}

export function DeleteTeamMemberRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DeleteTeamMemberRequest {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
  };
}

export function DeleteTeamMemberRequestToJSON(
  json: any,
): DeleteTeamMemberRequest {
  return DeleteTeamMemberRequestToJSONTyped(json, false);
}

export function DeleteTeamMemberRequestToJSONTyped(
  value?: DeleteTeamMemberRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
  };
}
